import api from '@/api'
 
interface ResponseWrapper<TResult> {
    result: TResult
    code: string
    message: string
    error: string | null
  }

export default {
  getTodayNoticePopupList(comCode: string) : Promise<Array<noticepopup.NoticeItem>>{
    return api.get({
      url: `/Common/NoticePopup/api/list/${comCode}`
    });
  },

  //#region 카운트 관련

  //timezoneoffset param 추가 //일정 정보 조회시 필요함
  getCount(): Promise<home.homeWebpartCount>{
    return api.get({
      url: `/api/hk/homewebpart/countNoEws`      
    })
  },
  //#endregion

  /* 토탈시스템 */
  //토탈시스템 링크목록
  search(options?: home.link.GroupSearchOptions): Promise<home.link.GroupSearchResult> {
    if (!options) {
      options = {
          code: null,
          name: null,
          useYn: true,
          systemCode: null
      }
    }
    return api.post<home.link.GroupSearchResult>({
        url: '/common/codeGroup',
        data: options
    })
  },

  getList(groupCode: string): Promise<home.link.Code[]> {
    return api.get<home.link.Code[]>({
        url: '/common/code?groupCode=' + groupCode
    })
  },

  // 토탈시스템 링크 토큰
  getEncryptedToken(comcode:string, token:string){
    return api.get({
      url : `/hk/HomeLink/EncryptToken?comcode=${comcode}&token=${token}`
    })
  },

  // 이지웰 암호화 파라미터
  getEncryptedParam(personId:string) :Promise<string>{
    return api.get({
      url:`/api/hk/EzwelEncrypt/encoded?personId=${personId}`
    })
  }
}